import React from 'react';
import ReactDOM from 'react-dom/client';
import { Navigate, BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Login from './paths/login/login.tsx';
import Home from './paths/home/home.tsx';
import Logout from './paths/login/logout.tsx';
import Decks from './paths/decks/decks.tsx';
import ViewDeck from './paths/decks/view.tsx';
import Header from './header.tsx';
import Games from './paths/games/initiation/games.tsx';
import Admin from './paths/admin/admin.tsx';
import Owner from './paths/owner/owner.tsx';
import WaitingForGame from './paths/games/initiation/waiting.tsx';
import Game from './paths/games/game.tsx';
import { Container } from 'react-bootstrap';
import axios from 'axios';
import MatchListPage from './paths/matchHistory/MatchHistory.tsx';
import { SocketProvider } from './game/socketContext.tsx';
import CardDemo from './paths/demo/CardDemo.tsx';
import Demo from './paths/demo/Demo.tsx';
import PlayerDataDemo from './paths/demo/PlayerDataDemo.tsx';
import HowToPlay from './paths/howToPlay/HowToPlay.tsx';

const root = ReactDOM.createRoot(document.getElementById('root')!);

export const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
});

root.render(
    <RouteRootComponent />
);

function RouteRootComponent() {

    return <>
        <BrowserRouter>
            <AppLayout>
                <Container fluid className='d-flex flex-column flex-grow-1 align-items-center p-0'>
                    <Routes>
                        <Route path='/' element={<PrivateRoute><Home /></PrivateRoute>} />

                        <Route path='/login' element={
                            <RedirectIfLoggedIn><Login /></RedirectIfLoggedIn>
                        } />
                        <Route path='/register' element={
                            <RedirectIfLoggedIn><Login /></RedirectIfLoggedIn>
                        } />

                        <Route path='/logout' element={<Logout />} />

                        {/* Protected routes */}
                        <Route path='/home' element={<PrivateRoute><Home /></PrivateRoute>} />
                        <Route path='/matchHistory' element={<PrivateRoute><MatchListPage /></PrivateRoute>} />
                        <Route path='/decks' element={<PrivateRoute><Decks /></PrivateRoute>} />
                        <Route path='/decks/:deckId' element={<PrivateRoute><ViewDeck /></PrivateRoute>} />
                        <Route path='/games' element={<PrivateRoute><Games /></PrivateRoute>} />
                        <Route path='/admin' element={<PrivateRoute><Admin /></PrivateRoute>} />
                        <Route path='/owner' element={<PrivateRoute><Owner /></PrivateRoute>} />
                        <Route path='/howToPlay' element={<PrivateRoute><HowToPlay /></PrivateRoute>} />


                        <Route element={<PrivateRoute><SocketProvider /></PrivateRoute>}>
                            <Route path='/games/waiting/:deckId' element={<WaitingForGame />} />
                            <Route path='/games/play' element={<Game />} />
                        </Route>

                        {/* Demo Displays */}
                        <Route path='/demo' element={<PrivateRoute><Demo /></PrivateRoute>} />
                        <Route path='/demo/cards' element={<PrivateRoute><CardDemo /></PrivateRoute>} />
                        <Route path='/demo/playerData' element={<PrivateRoute><PlayerDataDemo /></PrivateRoute>} />

                        <Route path='*' element={<>Invalid path</>} />
                    </Routes>
                </Container>
            </AppLayout>
        </BrowserRouter>
    </>
}

function AppLayout({ children }: { children: any }) {
    const location = useLocation();
    const hideHeaderPaths = ['/games/play'];
    const shouldHideHeader = hideHeaderPaths.find(l => location.pathname.startsWith(l));

    return <>
        <div className='d-flex flex-column min-vh-100'>
            {!shouldHideHeader && <Header />}
            {children}
        </div>
    </>;
}

export const RedirectIfLoggedIn: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const userData = JSON.parse(localStorage.getItem('userData') || 'null');

    if (userData) {
        return <Navigate to={'/home'} replace />;
    }
    return <>{children}</>;
};

export const PrivateRoute: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const userData = JSON.parse(localStorage.getItem('userData') || 'null');
    const location = useLocation();

    if (!userData) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return <>{children}</>;
};